import { NgModule } from '@angular/core';
import { CommonModule, OfferCalculatorPaymentScheduleModule } from 'common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TermLoanContentComponent } from './term-loan-content.component';
import { CurrencyPipe, PercentPipe } from '@angular/common';
import { ShareOfferModule } from '../share-offer/share-offer.module';
import { CalculatorClosingRequirementsModule } from '../calculator-closing-requirements/calculator-closing-requirements.module';
import { LinkYourBankModule } from '../link-your-bank/link-your-bank.module';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    ShareOfferModule,
    CalculatorClosingRequirementsModule,
    LinkYourBankModule,
    OfferCalculatorPaymentScheduleModule
  ],
  declarations: [
    TermLoanContentComponent
  ],
  exports: [
    TermLoanContentComponent
  ],
  providers: [
    PercentPipe,
    CurrencyPipe
  ]
})
export class TermLoanContentModule { }
